const rodzajFelgi = { t: 'Rodzaj felgi', name: 'rodzaj-felgi', hint: { url: '/part_rim_kind' }}
export default rodzajFelgi